<template>
  <div>
    <table :class="{'disabled':extraDataLoading}" v-if="!isMobile">
      <thead>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'name'}"
          @click="sort('name')">
          Brand Name
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'name'"></i>
        </th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'website'}"
          @click="sort('website')">
          Website
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'website'"></i>
        </th>
        <th>Webform</th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'phoneNumber'}"
          @click="sort('phoneNumber')">
          Phone #
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'phoneNumber'"></i>
        </th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'supportEmail'}"
          @click="sort('supportEmail')">
          Support Email
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'supportEmail'"></i>
        </th>
        <th>Send Email As</th>
        <th>Email Logo</th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'emailFAQ'}"
          @click="sort('emailFAQ')">
          FAQ
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'emailFAQ'"></i>
        </th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'emailTC'}"
          @click="sort('emailTC')">
          Terms
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'emailTC'"></i>
        </th>
      </thead>
      <tbody>
        <tr v-for="brand in brands">
          <td><a @click="editBrand(brand.id)">{{ brand.name }}</a></td>
          <td><a :href="brand.website" target="_blank">{{ brand.website }}</a></td>
          <td>
            <span v-if="!webformLoading">{{ webformName(brand.webformId) }}</span>
            <span v-else><i class="fas fa-spinner fa-spin"></i></span>
          </td>
          <td>{{ brand.phoneNumber }}</td>
          <td><a :href="'mailto:' + brand.supportEmail">{{ brand.supportEmail }}</a></td>
          <td>{{ brand.emailSendAs }}</td>
          <td><a :href="brand.emailLogoUrl" target="_blank">View</a></td>
          <td><a :href="brand.emailFAQ" target="_blank">{{ brand.emailFAQ }}</a></td>
          <td><a :href="brand.emailTC" target="_blank">{{ brand.emailTC }}</a></td>
        </tr>

        <tr v-show="loading && brands.length === 0">
          <td colspan="9" class="table-block">
            <transition name="slide-up">
              <div v-show="loading" class="loader">
                <i class="fas fa-spinner fa-spin"></i>
                Getting brands...
              </div>
            </transition>
          </td>
        </tr>

        <tr v-show="brands.length === 0 && !loading">
          <td colspan="9" class="table-block">
            <transition name="slide-up">
              <div v-show="brands.length === 0 && !loading" class="empty-result">
                <i class="far fa-frown-open fa-3x"></i><br/>
                No record found!
              </div>
            </transition>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="cards" v-else>
      <div class="card" v-for="brand in brands" :key="brand.id">
        <div class="card-header">
          <a @click="editBrand(brand.id)">{{ brand.name }}</a>
        </div>
        <div class="title">
          <div class="label">Website:</div>
          <div class="value"><a :href="brand.website" target="_blank">{{ brand.website }}</a></div>
        </div>
        <div class="title">
          <div class="label">Webform:</div>
          <div class="value">
            <span v-if="!webformLoading">{{ webformName(brand.webformId) }}</span>
            <span v-else><i class="fas fa-spinner fa-spin"></i></span>
          </div>
        </div>
        <div class="title">
          <div class="label">Phone: </div>
          <div class="value">{{ brand.phoneNumber }}</div>
        </div>
        <div class="title">
          <div class="label">Support Email: </div>
          <div class="value"><a :href="'mailto:' + brand.supportEmail">{{ brand.supportEmail }}</a></div>
        </div>
        <div class="title">
          <div class="label">Send Email As: </div>
          <div class="value">{{ brand.emailSendAs }}</div>
        </div>
        <div class="title">
          <div class="label">FAQ: </div>
          <div class="value"><a :href="brand.emailFAQ" target="_blank">{{ brand.emailFAQ }}</a></div>
        </div>
        <div class="title">
          <div class="label">Terms: </div>
          <div class="value"><a :href="brand.emailTC" target="_blank">{{ brand.emailTC }}</a></div>
        </div>
        <div class="title">
          <div class="label">Email Logo: </div>
          <div class="value"><a :href="brand.emailLogoUrl" target="_blank">View</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiBrands from '@/modules/api/brands'

export default {
  name: 'brand-list',
  props: ['isMobile'],
  components: {},
  data () {
    return {
      tab: 0,
      extraDataLoading: false
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list },
    loading () { return this.$store.state.brands.loading },
    webformLoading () { return this.$store.state.brands.webform.loading },
    currentOrder () {
      let brands = this.$store.state.brands
      return { field: brands.order, asc: brands.orderAsc }
    }
  },
  methods: {
    getBrands () {
      let self = this
      self.$store.commit('brands/setLoading', true)
      ApiBrands.getBrands(self, function (res) {
        self.$store.commit('brands/setLoading', false)
      })
    },
    editBrand (id) {
      let self = this
      let index = self.brands.findIndex(x => x.id === id)
      let brandData = Object.assign({}, self.brands[index])
      self.extraDataLoading = true
      ApiBrands.getExtraData(self, id, function (res) {
        if (!res.error) {
          brandData.facebookLink = res.facebookLink || ''
          brandData.twitterLink = res.twitterLink || ''
          brandData.appDownloadImg = res.appDownloadBanner || ''
          brandData.iosDownloadImg = res.appIOSDownloadButton || ''
          brandData.androidDownloadImg = res.appAndroidDownloadButton || ''
          brandData.textLink = res.textLink || ''
          brandData.fbAppID = res.facebookAppId || ''
          brandData.shareWording = res.shareWording || ''
          brandData.aboutLink = res.aboutLink || ''
          brandData.emailLink = res.emailLink || ''
          brandData.instagramLink = res.instagramLink || ''
        }

        self.$store.commit('brands/setEditBrands', brandData)
        // self.getServicesData(id, brandData)
        self.extraDataLoading = false
        self.getAppSettings()
        setTimeout(function () {
          self.$store.commit('brands/setShowBrandForm', true)
        }, 300)
      })
    },
    getAppSettings () {
      let self = this
      self.$sdk.get('/settings', {}, r => {
        self.$store.commit('brands/setBrandData', {
          charterEnabled: r.CharterEnabledBrands.value.split(',')
        })
        setTimeout(function () {
          self.$store.commit('brands/setShowBrandForm', true)
        }, 200)
      })
    },
    getServicesData (id, data) {
      let self = this
      let brandData = data
      ApiBrands.getServices(self, id, function (res) {
        if (!res.error) {
          res.forEach(function (service) {
            brandData[service.code + 'Img'] = service.image
            brandData[service.code + 'Label'] = service.name
          })
        }

        self.$store.commit('brands/setEditBrands', brandData)
        self.extraDataLoading = false
        setTimeout(function () {
          self.$store.commit('brands/setShowBrandForm', true)
        }, 300)
      })
    },
    webformName (id) {
      let webform = this.$store.state.brands.webform.list
      let index = webform.findIndex(x => x.id === id)
      return webform[index].name
    },
    sort (field) {
      if (this.loading) { return }
      let brands = this.$store.state.brands
      if (field !== brands.order) {
        this.$store.commit('brands/setBrandOrder', 1)
      } else {
        this.$store.commit('brands/setBrandOrderAsc', brands.orderAsc === 1 ? 0 : 1)
      }
      this.$store.commit('brands/setBrandOrder', field)
      this.getBrands()
    }
  },
  watch: {
    // provId: function (value) { this.init() }
  },
  mounted () {
    this.getBrands()
  }
}
</script>

<style lang="scss" scoped>
table{
  border-collapse: collapse;
  width: 100%;
  transition: all .5s ease;

  &.disabled{ opacity: .4; }
  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      &:nth-of-type(even) { background: #fbfbfb; }
      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  input{
    display: inline-block;
    width: auto;
  }
  .type{
    display: inline-block;
    padding: 3px 6px;
    text-transform: uppercase;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;

    &.tnc{ background: #2ab77c; }
    &.tcp{ background: #3f81a0; }
  }
  .status{ text-transform: capitalize; }
  .expired{ color: #de2929; }
  .fa-check-circle{ color: #0fda4e; }
  .fa-times-circle{ color: #ef3535; }
  a{ cursor: pointer; }
  .date{ word-spacing: 5px; }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
    .cards {
    padding-top: 20px;
    padding-bottom: 100px;
    .card {
      border: 1px solid #ccc;
      margin: 0 10px;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      font-weight: 700;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          font-weight: 900;
        }
        .amount {
          margin-left: 5px;
          font-size: 14px;
        }
        .status {
          text-transform: uppercase;
          font-size: 12px;
          font-weight: 900;
        }
      }

      .title {
        display: flex;
        align-items: center;
      }

      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;

        i {
          opacity: 0.3;
        }
      }

      .edit {
        text-align: right;
        margin-bottom: 10px;
        text-transform: uppercase;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Brands/BrandList.vue